module.exports = __webpack_public_path__ + "static/media/11_l_table_lamp_26.09_85.46.0a59f318.png";